/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ResourceJobSubject } from "./ResourceJobSubject";
import { CollectionJobSubject } from "./CollectionJobSubject";
export const JobSubject = core.serialization
    .union("type", {
    resource: ResourceJobSubject,
    collection: CollectionJobSubject,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
